import { render, staticRenderFns } from "./YWK_MigBoardLeftMenu.vue?vue&type=template&id=11c61458"
import script from "./YWK_MigBoardLeftMenu.ts?vue&type=script&lang=ts&external"
export * from "./YWK_MigBoardLeftMenu.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports